function setSearch() {

    $(".search_button").on("click", function () {
        $(".search-panel").fadeIn();
        $(this).next().show().css({
            display: "block"
        });
        $(this).hide();
    });

    $(".search_button_close").hide().on("click", function () {
        $(".search-panel").hide();
        $(this).prev().show();
        $(this).hide();
    });
}

$(document).ready(function ($) {
    setSearch();
});
